<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center mb-8">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
          <h4 style="margin-left: 10px">Products</h4>
        </div>
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button
            :to="{ name: 'master-product-add' }"
            class="btn mb-4 md:mb-0 mr-1"
            icon="add"
          >Add</vs-button>
          <vs-button
            :to="{ name: 'master-product-view',params: { id: selectedId }}"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeItem"
            icon="delete"
            :disabled="selectedId ? false : true"
          >Delete</vs-button>
          <vs-button class="mb-4 md:mb-0 mr-1" @click="filterActive" icon="filter_list">Filter</vs-button>
          <vs-dropdown>
            <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
                  <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                  <input
                      type="file"
                      ref="file"
                      style="display: none"
                      v-on:change="uploadExcel"
                  />
              <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="products"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="single"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>
          Showing {{ dataFrom }} to {{ dataTo }} of
          {{ dataTotal }} total entries
        </b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

      <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
        <div class="con-exemple-prompt">
          <!-- <vs-input placeholder="Product ID" v-model="filter.product_id" class="mt-4 mb-2 w-full" /> -->
          <vs-input
            placeholder="Product Code"
            v-model="filter.product_code"
            class="mt-4 mb-2 w-full"
          />
          <vs-input
            placeholder="Description 1"
            v-model="filter.description_1"
            class="mt-4 mb-2 w-full"
          />
          <vs-input
            placeholder="Description 2"
            v-model="filter.description_2"
            class="mt-4 mb-2 w-full"
          />
          <vs-select
            class="mt-4 mb-2 w-full"
            placeholder="Client Code"
            autocomplete
            v-model="filter.client_id"
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.client_code"
              v-for="(item, index) in clients"
            />
          </vs-select>
          <vs-select
            class="mt-4 mb-2 w-full"
            placeholder="Product category"
            autocomplete
            v-model="filter.product_categories_id"
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item, index) in product_categories"
            />
          </vs-select>
        </div>
      </vs-prompt>
    </vx-card>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      selectedId: null,
      isLoading: false,
      maxRetry: 10,
      showFilter: false,
      filter: {
        product_code: null,
        description_1: null,
        description_2: null,
        client_id: null,
        product_categories_id: null
      },
      product_categories: [],
      products: [],
      clients: [],
      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    },

    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchProduct();
    }
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    fetchProduct(){
      this.isLoading = true;
       this.$http.post("master/product?page="+this.currentPage, this.filter)
       .then((products) => {
            this.products = [];
            this.products = products.data.data;
            this.totalPage = products.data.last_page;
            this.currentPage = this.currentPage;
            this.dataTotal = products.data.total;
            this.dataFrom = products.data.from;
            this.dataTo = products.data.to;
            this.isLoading = false;
       })
       .catch((error)=>{
            this.isLoading = false;
            console.log(error)
       })
    },
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    removeItem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this product?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.isLoading = true;
      this.$http
        .delete("master/product/" + this.selectedId + "/destroy")
        .then(() => {
          this.$vs.notify({
            color: "success",
            title: "Product deleted",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected product was successfully deleted"
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Error",
            text: "Error.",
            color: "danger"
          });
        })
        .then(() => {
          this.fetchData();
        });
    },
    refreshData() {
      this.maxRetry = 10;
      this.fetchData();
    },
    fetchData() {
      this.isLoading = true;
      this.maxRetry = this.maxRetry - 1;

      this.$http
        .all([
          this.$http.post("master/product?page="+this.currentPage),
          this.$http.post("master/clients"),
          //this.$http.post("master/productcategories")
          this.$http.post("master/productcategorieslov")
        ])
        .then(
          this.$http.spread((products, clients, productcategories) => {
            this.products = products.data.data;
            this.totalPage = products.data.last_page;
            this.currentPage = this.currentPage;
            this.dataTotal = products.data.total;
            this.dataFrom = products.data.from;
            this.dataTo = products.data.to;
            this.clients = clients.data.data;
            this.product_categories = productcategories.data.data;
            this.isLoading = false;
          })
        )
        .catch(() => {
          if (this.maxRetry == 0) {
            this.isLoading = false;
            this.$vs.dialog({
              type: "confirm",
              color: "danger",
              title: "Server Error",
              text: "Try again?",
              accept: () => {
                this.maxRetry = 10;
              },
              cancel: () => this.$router.go(-1),
              acceptText: "Yes",
              cancelText: "No"
            });
            return;
          }
        });

      // Promise.all([
      //   this.$http.post("master/product"),
      // ])
      //   .then(res => {
      //     this.isLoading = !this.isLoading;
      //     this.products = res[0].data;
      //   })
      //   .catch(() => {
      //     if (this.maxRetry == 0) {
      //       this.isLoading = false;
      //       this.$vs.dialog({
      //         type: "confirm",
      //         color: "danger",
      //         title: "Server Error",
      //         text: "Try again?",
      //         accept: () => {
      //           this.refreshData();
      //         },
      //         acceptText: "Yes",
      //         cancelText: "No"
      //       });
      //       return;
      //     }
      //     this.fetchData();
      //   });
    },
    viewData() {
      this.$router.push({
        name: "master-product-view",
        params: {
          id: this.selectedId
        }
      });
    },
    filterData() {
      this.isLoading = true;
      this.$http
        .post("master/product", this.filter)
        .then(resp => {
          this.products = resp.data.data;
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
    },
    filterActive() {
      this.showFilter = !this.showFilter;

      this.filter = {
        product_code: null,
        description1: null,
        description2: null,
        client_id: null,
        product_category: null
      };
    },
   getTemplate() {
            this.isLoading = true;
            this.$http
                .get("master/product/report/gettemplate", {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "product-template.xlsx");
                });
    },
     uploadExcel() {
            let file = event.target.files[0];
            let form = new FormData();
            form.append("file", file);
            this.isLoading = true;
            this.$http
                .post("/master/product/report/importexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(resp => {
                    this.isLoading = false;
                    this.fetchData();
                    this.$vs.notify({
                        color: "success",
                        title: "Upload Success",
                        text: "Upload Data Product Successfully"
                    });
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
    },
    exportExcel() {
      console.log("Export Excel");

      this.isLoading = true;
            this.$http
                .post("master/product/report/exportexcel", this.filter, {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "Products-list-export.xlsx");
                });
    }
  },
  mounted() {
    this.fetchData();
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      // {
      //   headerName: "Product ID",
      //   field: "id",
      //   width: 150,
      // },
      {
        headerName: "Product Code",
        field: "product_code",
        width: 250,
      },
      {
        headerName: "Description 1",
        field: "description_1",
        width: 400
      },
      {
        headerName: "Description 2",
        field: "description_2",
        width: 250
      },
      {
        headerName: "Client",
        field: "clients.client_code",
        width: 180
      },
      {
        headerName: "Product Category",
        field: "productcategories.name",
        width: 180
      },
      {
        headerName: "Status",
        field: "is_active.name",
        width: 120
      }
    ];
    this.gridOptions.getRowHeight = function(params) {
        return 35;
    }
  }
};
</script>
